import React from 'react';
import EditPage from './EditPage';
import AnnouncementBarManager from './AnnouncementBarManager';

const Advertisement = () => {
  return (
    <div>
      <EditPage />
      <AnnouncementBarManager />
    </div>
  );
};

export default Advertisement;
